export default {
  containerVisitas: {
    semVisitas: 'No visits in 14 days',
    visitasAgendadas: 'Scheduled Visits',
    visitasRealizadas: 'Visits made'
  }
};
